export default {
  hotArea: '热门地区',
  hotIndustry: '热门行业',
  hotExhibition: '热门展会'
}
